import { styled } from "@mui/material/styles";
import { Box, Button, Typography, TableCell, Card } from "@mui/material";
import colors from "../../theme/Colours";

export const StyledLabelCell = styled(TableCell)(({ theme }) => ({
  color: "#000",
  fontWeight: 600,
  fontSize: "18px",
  borderBottom: "none",
  padding: `${theme.spacing(3)} ${theme.spacing(1.5)}`,
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
    padding: `${theme.spacing(1.375)} 0`,
  },
}));

export const StyledCell = styled(TableCell)(({ theme }) => ({
  fontSize: "16px",
  padding: `${theme.spacing(3.25)} ${theme.spacing(1.5)}`,
  borderBottom: "none",
  [theme.breakpoints.down("sm")]: {
    fontSize: "10px",
    padding: `${theme.spacing(1.375)} 0`,
  },
}));

export const EmptyContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  marginTop: theme.spacing(8.375),
}));

export const EmptyOrdersSVG = styled("img")({
  maxWidth: "420px",
});

export const StyledActionButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  width: isMobile ? "80px" : "131.22px",
  height: isMobile ? "24px" : "29px",
  padding: isMobile ? "2px 8px" : "4px 12px",
  fontSize: isMobile ? "8px" : "14px",
  gap: "10px",
  borderRadius: "60px",
  border: `1px solid ${colors.primaryButtonOrange}`,
  backgroundColor: "#fff",
  color: colors.primaryButtonOrange,
  "&:hover": {
    backgroundColor: colors.primaryButtonOrange,
    color: "#fff",
  },
  whiteSpace: "nowrap",
}));

export const Heading = styled(Typography)(({ theme }) => ({
  fontSize: "36px",
  fontWeight: 500,
  marginBottom: theme.spacing(3),
}));

export const CardStyle = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
}));
